/**
 * The single place this app leaves itself.
 *
 * Exists so that redirect behaviour is testable: jsdom cannot assign to
 * window.location, and mocking this module keeps the test boundary at the edge of the app
 * instead of forcing components to take a navigation function as a prop.
 */

/**
 * Send the browser to an absolute URL.
 *
 * @param {string} url
 */
export const navigateTo = (url) => {
    window.location.href = url;
};
